<div class="image-feed-container">
    <div *ngIf="imageViewSettings.annotationParams.enabled === true" class="image-feed__legend"> 
        <i class="dku-icon-info-circle-fill-16 mright4"></i>
        <span>
            Labels displayed are based on column <em>{{imageViewSettings.annotationParams.annotationColumn}}</em>.
            <a [href]="$state.href('projects.project.datasets.dataset.settings', { datasetName: inputDatasetName, '#': 'advanced'})"> Go to Settings</a> 
        </span>
    </div>
    <image-feed class="image-feed" [imageHeight]="200" [itemsPerRow]="4" (imageClick)="openModal($event)"></image-feed>
</div>